import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as oidcReducer } from 'redux-oidc';
import servicePropertiesReducer from "./reducers/serviceProperties";
import userManagerReducer from "./reducers/userManager";
import { localizeReducer } from 'react-localize-redux';
import axiosReducer from './reducers/axios';
import userReducer from "./reducers/user";
import i18nReducer from "./reducers/i18n";
import activeTaskResourceReducer from "./reducers/activeTaskResource";
import schemaReducer from "./reducers/schema";
import editorReducer from "./reducers/editor";
var createRootReducer = function (reducers, history) {
    if (reducers === void 0) { reducers = {}; }
    var baseReducers = {
        router: connectRouter(history),
        oidc: oidcReducer,
        serviceProperties: servicePropertiesReducer,
        userManager: userManagerReducer,
        localize: localizeReducer,
        axios: axiosReducer,
        i18n: i18nReducer,
        user: userReducer,
        activeTaskResource: activeTaskResourceReducer,
        schema: schemaReducer,
        editor: editorReducer,
    };
    Object.keys(baseReducers).forEach(function (key) {
        if (reducers.hasOwnProperty(key)) {
            throw new Error("Reducer key: " + key + " is reserved");
        }
    });
    return combineReducers(Object.assign(baseReducers, reducers));
};
export default createRootReducer;
